import { Record, List } from 'immutable';

import Hydrator from 'utils/Hydrator';
import FundingSearchReportModel from './FundingSearchReportModel';

const DocumentLogRecord = Record({
  id: 0,
  createdAt: 0,
});

class DocumentLogModel extends DocumentLogRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {
      createdAt: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new DocumentLogModel(hydrated);
  }
}

const UserReportRecord = Record({
  id: 0,
  name: '',
  email: '',
  teamId: 0,
  lastLogin: null,
  totalLessons: 0,
  createdSearches: 0,
  completedLessons: 0,
  uploadedDocuments: List(),
  lastLessonCompletedDate: null,
  fundingSearchesCreated: List(),
  managedFundingSearches: List(),
  firstLessonCompletedDate: null,
});

export default class UserReportModel extends UserReportRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {
      lastLogin: Hydrator.timestamp2Date,
      lastLessonCompletedDate: Hydrator.timestamp2Date,
      firstLessonCompletedDate: Hydrator.timestamp2Date,
      uploadedDocuments: Hydrator.fromList(DocumentLogModel.deserialize),
      fundingSearchesCreated: Hydrator.fromList(FundingSearchReportModel.deserialize),
      managedFundingSearches: Hydrator.fromList(FundingSearchReportModel.deserialize),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new UserReportModel(hydrated);
  }

  hasLearnData() {
    return typeof this.totalLessons === 'number' && this.totalLessons > 0;
  }

  completedLessonPercentage() {
    return this.hasLearnData() ? (this.completedLessons / this.totalLessons) * 100 : 0;
  }
}
